const READING_SCALES = [
  {
    id: '1',
    locale: 'us',
    'blake-reading-level': 0,
    'book-colour': 'Pink',
    dra: 'A',
    'fp-az': 'A',
    'lexile-range': 'BR',
    'lexile-range-lower': 'BR',
    'lexile-range-upper': '0L',
    'rr-level': 1,
    'year-level': 'Pre-K',
    'has-big-books': false,
    'fp-peaks': [1, 2, 3],
  },
  {
    id: '2',
    locale: 'us',
    'blake-reading-level': 1,
    'book-colour': 'Pink',
    dra: '1',
    'fp-az': 'A',
    'lexile-range': '10L-20L',
    'lexile-range-lower': '10L',
    'lexile-range-upper': '20L',
    'rr-level': 1,
    'year-level': 'Kindergarten',
    'has-big-books': true,
    'fp-peaks': [1, 2, 3],
  },
  // intentionally out of order, as the backend may provide them out of order. Make sure you sort them!
  {
    id: '5',
    locale: 'us',
    'blake-reading-level': 4,
    'book-colour': 'Red',
    dra: '3',
    'fp-az': 'C',
    'lexile-range': '90L+',
    'lexile-range-lower': '90L',
    'lexile-range-upper': '90L+',
    'rr-level': 4,
    'year-level': 'Grade 1',
    'has-big-books': true,
    'fp-peaks': [1, 2, 3],
  },
  {
    id: '3',
    locale: 'us',
    'blake-reading-level': 2,
    'book-colour': 'Pink',
    dra: '2',
    'fp-az': 'B',
    'lexile-range': '30L',
    'lexile-range-lower': '30L',
    'lexile-range-upper': '30L',
    'rr-level': 2,
    'year-level': 'Grade 2',
    'has-big-books': true,
    'fp-peaks': [1, 2, 3],
  },
  {
    id: '4',
    locale: 'us',
    'blake-reading-level': 3,
    'book-colour': 'Red',
    dra: '2',
    'fp-az': 'C',
    'lexile-range': '40L-50L',
    'lexile-range-lower': '40L',
    'lexile-range-upper': '50L',
    'rr-level': 3,
    'year-level': 'Grade 3',
    'has-big-books': true,
  },
]

export default READING_SCALES
